// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2tuhw","image":"Header_image__2Xl7j","name":"Header_name__31yo1","info":"Header_info__3FUAl","infoRow":"Header_infoRow__2bSex"};